export enum BillingType {
    Manual = 'manual',
    MarkedAsPaid = 'marked-as-paid',
    Subscription = 'subscription',
}
